import { render } from "./DocumenttypesIndex.vue?vue&type=template&id=a683b164&ts=true"
import script from "./DocumenttypesIndex.vue?vue&type=script&lang=ts"
export * from "./DocumenttypesIndex.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__